import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const customField1Type = 'CustomFieldOne';

const Custom1Expanded = ({ fulfillmentPlanId }) => {
  const notes =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'notes',
      }),
    ) ?? [];
  const customField1 = notes.find((note) => note.type === customField1Type);

  return customField1?.body ?? '';
};

Custom1Expanded.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Custom1 = {
  getMessageDescriptor: () => messages.custom1,
  id: 'custom1',

  render: (data, { isFirstOfType = true } = {}) => {
    if (!data || !isFirstOfType) {
      return '';
    }
    return <Custom1Expanded fulfillmentPlanId={data.id} />;
  },
};
